// context/LanguageContext.js
import React, { createContext, useState, useEffect } from "react";

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {

    // Liste des langues prises en charge
    const SUPPORTED_LANGUAGES = ["fr", "en", "de", "es", "it"];
    // Détection automatique de la langue du navigateur ou récupération depuis localStorage

    // Validation de la langue détectée
    const getBrowserLanguage = () => {
        const browserLang = (navigator.language || "fr").split("-")[0];
        return SUPPORTED_LANGUAGES.includes(browserLang) ? browserLang : "fr";
    };

    const defaultLang = localStorage.getItem("lang") || getBrowserLanguage();

    const [language, setLanguage] = useState(localStorage.getItem("lang") || defaultLang);

    // Mettre à jour localStorage quand la langue change
    useEffect(() => {
        localStorage.setItem("lang", language);
    }, [language]);

    // Fonction pour changer la langue
    const changeLanguage = (lang) => {
        //ici
        setLanguage(lang);
    };
    

    return (
        <LanguageContext.Provider value={{ language, changeLanguage }}>
            {children}
        </LanguageContext.Provider>
    );
};
